module.exports = __webpack_public_path__ + "img/re-logo-tight.c87f2db3.svg";